'use client';
import styles from './bottomNavigation.module.scss';
import { PATH } from 'data';
import { TbSmartHome, TbSquarePlus, TbUserSquareRounded } from 'react-icons/tb';
import { COLORS } from 'utilities';
import { RxDashboard } from 'react-icons/rx';
import { HiOutlineChatBubbleOvalLeftEllipsis } from 'react-icons/hi2';
import { useContext, useEffect, useState } from 'react';
import { GlobalContext } from 'context';
import { ThemeEnum } from 'types';
import AppLinkComp from 'components/appLink/appLink.index';
import { usePathname } from 'next/navigation';
import { Link, useInRouterContext } from 'react-router-dom';
import { RestAPI } from 'scripts';
import { API } from 'data';
import { Badge } from 'antd';

function BottomNavigationComp() {
    const { theme, profile } = useContext(GlobalContext);
    const pathname = usePathname();
    const routerContext = useInRouterContext();
    const [unreadCount, setUnreadCount] = useState(0);

    useEffect(() => {
        // Only start interval if user is logged in
        // Initial fetch
        fetchUnreadCount();

        // Set up interval
        const interval = setInterval(fetchUnreadCount, 10000);

        // Cleanup interval on unmount
        return () => clearInterval(interval);
    }, []);

    const fetchUnreadCount = () => {
        if (profile) {
            RestAPI.get<number>(API.chat.unreadCount).then((res) => {
                setUnreadCount(res.data);
            });
        }
    };

    const AdvanceLink: React.FC<React.PropsWithChildren<{ href: string; className?: string }>> = (props) =>
        routerContext ? (
            <Link to={props.href} className={props.className}>
                {props.children}
            </Link>
        ) : (
            <AppLinkComp href={props.href} className={props.className}>
                {props.children}
            </AppLinkComp>
        );

    const routeChecker = (route: string, type: 'icon' | 'text') => {
        if (type === 'text') {
            if (route === pathname) return styles['active'];
            return '';
        }
        if (type === 'icon') {
            if (route === pathname) return COLORS.primary;
            if (theme === ThemeEnum.dark) return COLORS.gray1;
            if (theme === ThemeEnum.light) return COLORS.black1;
            return COLORS.gray1;
        }
    };

    return (
        <div className={`${styles['bottom-navigation']} w-100 d-md-none center-content-y ph-2`}>
            <div className={`${styles['items']} w-100 d-flex center-content-y justify-content-between g-4`}>
                <AdvanceLink href={PATH.home}>
                    <div className={`${routeChecker(PATH.home, 'text')} flex-column center-content`}>
                        <TbSmartHome size={22} color={routeChecker(PATH.home, 'icon')} />
                        <p className="t-p3 t-400">خانه</p>
                    </div>
                </AdvanceLink>
                <AdvanceLink href={PATH.categories()}>
                    <div className={`${routeChecker(PATH.categories(), 'text')} flex-column center-content`}>
                        <RxDashboard size={22} color={routeChecker(PATH.categories(), 'icon')} />
                        <p className="t-l-black1 t-d-gray2 t-p3 t-400">دسته ها</p>
                    </div>
                </AdvanceLink>
                <AdvanceLink href={!profile ? PATH.login(PATH.panel.addPost.index()) : PATH.panel.addPost.index()}>
                    <div className={`${routeChecker(PATH.panel.addPost.index(), 'text')} flex-column center-content`}>
                        <TbSquarePlus size={22} color={routeChecker(PATH.panel.addPost.index(), 'icon')} />
                        <p className="t-l-black1 t-d-gray2 t-p3 t-400">ثبت آگهی</p>
                    </div>
                </AdvanceLink>
                <AdvanceLink href={PATH.panel.chat()}>
                    <div className={`${routeChecker(PATH.panel.chat(), 'text')} flex-column center-content`}>
                        <Badge count={unreadCount} overflowCount={99}>
                            <HiOutlineChatBubbleOvalLeftEllipsis
                                size={22}
                                color={routeChecker(PATH.panel.chat(), 'icon')}
                            />
                        </Badge>
                        <p className="t-l-black1 t-d-gray2 t-p3 t-400">چت</p>
                    </div>
                </AdvanceLink>
                <AdvanceLink href={PATH.panel.mobileMenu()}>
                    <div className={`${routeChecker(PATH.panel.mobileMenu(), 'text')} flex-column center-content`}>
                        <TbUserSquareRounded size={22} color={routeChecker(PATH.panel.mobileMenu(), 'icon')} />
                        <p className="t-l-black1 t-d-gray2 t-p3 t-400">پروفایل من</p>
                    </div>
                </AdvanceLink>
            </div>
        </div>
    );
}

export default BottomNavigationComp;
